// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title[data-v-33b94fb9]{height:3.5rem;-webkit-line-clamp:2}.description[data-v-33b94fb9],.title[data-v-33b94fb9]{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical}.description[data-v-33b94fb9]{height:7.5rem;-webkit-line-clamp:6}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
